import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useAddCart} from '../../context/useMutation'
import {useMarket} from '../../hook'

export default function MarketPlace({search, refetch}: {search: string; refetch: any}) {
  const intl = useIntl()
  const {mutateAsync} = useAddCart()
  const {list, basketId, basket} = useMarket()
  const [basketItemList, setBasketItemList] = useState<any[]>([])

  useEffect(() => {
    if (basket) {
      const productIds = basket?.basketItemList.map((x: any) => x.product.id)
      setBasketItemList(productIds)
    }
  }, [basket])

  const addItem = async (productId: any) => {
    await mutateAsync({productId, type: 0, basketId: basketId, count: 1})
    refetch()
  }

  return (
    <div className='mb-11'>
      <div className='d-flex justify-content-between align-items-center mb-7'>
        <h2 className='font-weight-bolder text-dark font-size-h3 mb-0'>
          {intl.formatMessage({id: 'MARKET.PRODUCTS'})}
        </h2>
        <a href={`/market-place/cart`} className='btn btn-light-primary btn-sm font-weight-bolder'>
          {intl.formatMessage({id: 'MARKET.CART'})} ({basket?.basketItemList.length || 0})
        </a>
      </div>

      <div className='row'>
        {list.dataList.map((item, index) => {
          if (search && item.productName.toLowerCase().indexOf(search.toLowerCase()) === -1)
            return null
          // const basketCheck = basket?.basketItemList.find((x: any) => x.product.id === item.id) ? true : false;
          const basketCheck = basketItemList.find((x: any) => x === item.id) ? true : false

          return (
            <div className='col-md-3 col-xl-3 col-lg-12' key={index}>
              <div className='card card-custom card-shadowless'>
                <div className='card-body p-0'>
                  <div className='overlay'>
                    <div className='overlay-wrapper rounded bg-light text-center'>
                      <img src={item.image} alt='' className='mw-100 w-200px' />
                    </div>
                    <div className='overlay-layer'>
                      <a
                        href={`/market-place/${item.id}`}
                        className='btn font-weight-bolder btn-sm btn-primary mr-2'
                      >
                        {intl.formatMessage({id: 'MARKET.DETAIL'})}
                      </a>
                      <button
                        className='btn font-weight-bolder btn-sm btn-light-primary'
                        disabled={basketCheck}
                        onClick={() => {
                          if (basketCheck) return
                          setBasketItemList([...basketItemList, item.id])
                          addItem(item.id)
                        }}
                      >
                        {basketCheck
                          ? intl.formatMessage({id: 'MARKET.ADDED_CART'})
                          : intl.formatMessage({id: 'MARKET.ADD_CART'})}
                      </button>
                    </div>
                  </div>

                  <div className='text-center mt-5 mb-md-0 mb-lg-5 mb-md-0 mb-lg-5 mb-lg-0 mb-5 d-flex flex-column'>
                    <a
                      href={`/market-place/${item.id}`}
                      className='font-size-h5 font-weight-bolder text-dark-75 text-hover-primary mb-1'
                    >
                      {item.productName}
                    </a>
                    {/* <span className="font-size-lg mb-3">{item.description}</span> */}
                    <h5 className='font-weight-bolder'>{item.price}AED</h5>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
